import script from "./TableDataDlg.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableDataDlg.vue?vue&type=script&lang=ts&setup=true"

import "./TableDataDlg.vue?vue&type=style&index=0&id=0d26350d&lang=css"

const __exports__ = script;

export default __exports__